<template>
    <div class="todo todo-wrapper" :id="'todoList-' + [todo.id]" draggable="true">
        <input
          type="checkbox" 
          name="check todo as complete"
          class="todo__checkbox" 
          :id="'tic-' + [todo.id]" 
          v-model="isChecked" 
          @change="updateCheckedState"
          @keydown.enter="onCheckboxEnter"
        >
        <label class="todo__label" :for="'tic-' + [todo.id]">
            <div class="todo__label__tic-container">
                <span class="todo__label__tic-container__tic todo__label__tic-container__tic--layer-1"></span>
                <span class="todo__label__tic-container__tic todo__label__tic-container__tic--layer-2"></span>
                <span class="todo__label__tic-container__tic todo__label__tic-container__tic--layer-3"></span>
            </div>
            <span class="todo__label__text" >{{ todo.item }}</span>
        </label>
        <button class="todo__delete-btn" aria-label="delete todo" @click="$emit('on-delete-btn-click')"></button>
    </div>
</template>

<script>
export default {
    name: "TodoItem",
    props: {
        todo: Object,
        todoList: Array,
    },
    data() {
        return {
            isChecked: this.todo.isComplete, // Setting checkbox value to todoList array's value
            checkedTodoId: this.todo.id,
        }
    },
    methods: {
        updateCheckedState: function() {
            this.todo.isComplete = this.isChecked;
            localStorage.setItem('todoList',JSON.stringify(this.todoList));
        },
        onCheckboxEnter : function() {
            this.isChecked = (this.isChecked === true) ? false : true;
            this.updateCheckedState();
        }
    }
}
</script>

<style>

:root {
    --dlt-btn--width: 64px; /* should be fluid */
    --label-width: calc(100% - var(--dlt-btn--width));
}

.todo {
    --duration: 500ms;
    
    border-radius: 0px;
    border-bottom: 1px solid var(--todo-border-clr);
    position: relative;
}

/* hide checkbox from view */
.todo__checkbox {
    opacity: 0;
    height: 0;
    width: 0;
}

.todo__label {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 100%;
}

.todo__label__tic-container {
    display: flex;
    align-items: center;
    position: relative;

    height: var(--todo-height);
    width: var(--todo-height);
    isolation: isolate;
}

/* common styles - layers*/
.todo__label__tic-container__tic {
    position: absolute;
    width: 37.5%;
    height: 37.5%;
    margin-left: 37.5%;
    border-radius: 50%;
    transition: opacity var(--duration);
}

/* bottom layer - appear on hover */
.todo__label__tic-container__tic--layer-1 {
    background-image: linear-gradient(hsl(192, 100%, 67%), hsl(280, 87%, 65%)),
                      url(../../../assets/icon-check.svg);
    background-repeat: no-repeat;
    background-blend-mode: color;
    background-position: center;

    opacity: 0;
}

/* middle layer - disappear on hover */
.todo__label__tic-container__tic--layer-2 {
    background-image: linear-gradient(var(--circle-border-clr), var(--circle-border-clr));
    opacity: 1;
}

/* top most layer - to hide the middle section of the circle to make it look like a ring */
.todo__label__tic-container__tic--layer-3 {
    width : calc( 37.5% - 3px );        /* override */
    height: calc( 37.5% - 3px );        /* override */
    margin-left: calc( 37.5% + 1.4px ); /* override */
    background-image: linear-gradient(var(--bg-todo-clr), var(--bg-todo-clr));
    transform: scale(0.99);

    opacity: 1;
}

/* label hover state */
.todo__label:hover .todo__label__tic-container__tic--layer-1 { opacity: 1 }
.todo__label:hover .todo__label__tic-container__tic--layer-2 { opacity: 0 }
.todo__label:hover + .todo__delete-btn    { opacity: 1 }
.todo__checkbox:focus ~ .todo__delete-btn { opacity: 1 }

/* checkbox focus state */
.todo__checkbox:focus + .todo__label .todo__label__tic-container__tic { transition: opacity 0ms}
.todo__checkbox:focus + .todo__label .todo__label__tic-container__tic--layer-1 { opacity: 1 }
.todo__checkbox:focus + .todo__label .todo__label__tic-container__tic--layer-2 { opacity: 0 }
.todo__checkbox:focus + .todo__label .todo__label__tic-container__tic--layer-3 { 
    opacity: 1;
    background-image: linear-gradient( var(--bg-todo-clr), var(--bg-todo-clr)),
                      url(../../../assets/icon-check.svg);
    background-repeat: no-repeat;
    background-blend-mode: color;
    background-position: center;
}

/* checkbox checked state */
.todo__checkbox:checked + .todo__label .todo__label__tic-container__tic--layer-1 {
    opacity: 1;
    animation: tic-animation 300ms forwards;
}
.todo__checkbox:checked + .todo__label .todo__label__tic-container__tic--layer-2 { opacity: 0 }
.todo__checkbox:checked + .todo__label .todo__label__tic-container__tic--layer-3 { opacity: 0 }
.todo__checkbox:checked + .todo__label .todo__label__text { 
    text-decoration: line-through;
    color: var(--todo-completed-text-clr);
}

.todo__label__text {
    display: block;
    width: calc(var(--label-width) - var(--todo-height));
    color: var(--todo-text-clr);
    text-decoration: none;
    transition: text-decoration var(--duration), color var(--duration);
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    text-indent: 10px;
    scrollbar-width: none;
}

.todo__label__text::-webkit-scrollbar { display: none }


/* appears on hover and focus*/
.todo__delete-btn {
    position: absolute;
    top: 0;
    right: 0;

    width: var(--dlt-btn--width);
    height: 100%;

    background: transparent;
    border: none;
    cursor: pointer;
    background: url(../../../assets/icon-cross.svg) no-repeat center;
    opacity: 0;
    transition: opacity var(--duration);
}

.todo__delete-btn:is(:hover, :focus) { opacity: 1 }

/* delete buttn focus state */
.todo__delete-btn:focus {
    outline: transparent;
    border: 1.5px solid var(--todo-border-clr); /* darkslateblue */
    transition: opacity 0ms;
}

@keyframes tic-animation {
    0% {
        transform: scale(.8);
    }
    90% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

</style>